// Only non-secret values belong here: everything in this file is readable in the
// browser bundle. Kavach credentials live in the API environment; the token is
// issued by POST /auth/token.
export const config = {
    // local
    'chatbotbackendapi': 'https://stage-chatbot.xbees.in/webhook',
    // stage
    // 'chatbotbackendapi': 'https://stage-chatbot.xbees.in/webhook',
}
